import React from "react";

const TrackPatientsModal = ({ isOpen, onClose, title, description, children, actions }) => {
  const hasBody = Boolean(description || children);

  return (
    <div className={`modal ${isOpen ? "is-active" : ""}`}>
      <div className="modal-background" onClick={onClose} />
      <div className="modal-content track-patients-modal" role="dialog" aria-modal="true" aria-label={title}>
        <div className="track-patients-dialog">
          <header className="track-patients-dialog-header">
            <h2 className="track-patients-dialog-title">{title}</h2>
            <button className="delete" type="button" aria-label="close" onClick={onClose} />
          </header>
          {hasBody && (
            <div className="track-patients-dialog-body">
              {description && <p className="track-patients-dialog-description">{description}</p>}
              {children}
            </div>
          )}
          {actions?.length > 0 && (
            <footer className="track-patients-dialog-footer">
              {actions.map((action) => (
                <button
                  key={action.text}
                  type="button"
                  className={`button is-small is-radiusless ${
                    action.primary ? "is-link" : "has-background-light has-text-primary"
                  }`}
                  onClick={action.onClick}
                >
                  {action.text}
                </button>
              ))}
            </footer>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrackPatientsModal;
